import React, { useState } from 'react';
import { Box, Button, TextField, Typography, Link, IconButton, InputAdornment } from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
// 追加: Amplify関連
import { Auth } from 'aws-amplify';

type Props = {
  onLoginSuccess: () => void;
};

const LoginForm: React.FC<Props> = ({ onLoginSuccess }) => {
  const [userId, setUserId] = useState('');
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  // 追加: エラーメッセージ状態
  const [errorMsg, setErrorMsg] = useState('');

  // 追加: Cognito認証API呼び出し（③）
  const handleLogin = async () => {
    setErrorMsg(''); // エラーメッセージ初期化
    try {
      // Cognito認証API呼び出し
      await Auth.signIn(userId, password);
      // 認証成功時（②画面に遷移）
      onLoginSuccess();
    } catch (error) {
      // 認証失敗時（①画面でエラーメッセージ表示）
      setErrorMsg('IDもしくはパスワードが違います');
    }
  };

  return (
    <Box
      sx={{
        maxWidth: 400,
        margin: '40px auto',
        padding: 3,
        border: '1px solid #ccc',
        borderRadius: 2,
        boxShadow: 2,
      }}
    >
      {/* 画面名を「ログイン」に変更 */}
      <Typography variant="h5" align="center" gutterBottom>
        ログイン
      </Typography>
      {/* 追加: エラーメッセージ表示エリア（常に高さ確保） */}
      <Box sx={{ minHeight: 24, mb: 1, textAlign: 'center' }}>
        {errorMsg && (
          <Typography
            variant="body2"
            color="error"
            sx={{ fontSize: '0.9rem', fontWeight: 'bold' }}
          >
            {errorMsg}
          </Typography>
        )}
      </Box>
      <TextField
        label="ID"
        variant="outlined"
        fullWidth
        margin="normal"
        value={userId}
        onChange={(e) => setUserId(e.target.value)}
      />
      <TextField
        label="パスワード"
        variant="outlined"
        fullWidth
        margin="normal"
        type={showPassword ? 'text' : 'password'}
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                aria-label="パスワード表示切替"
                onClick={() => setShowPassword((show) => !show)}
                edge="end"
              >
                {showPassword ? <VisibilityOff /> : <Visibility />}
              </IconButton>
            </InputAdornment>
          ),
        }}
      />
      <Button
        variant="contained"
        color="primary"
        fullWidth
        sx={{ mt: 2 }}
        onClick={handleLogin} // 追加: Cognito認証API呼び出し
        disabled={!userId || !password}
      >
        ログイン
      </Button>
      <Box sx={{ mt: 2, textAlign: 'center' }}>
        <Link href="#" underline="hover">
          ID新規登録
        </Link>
      </Box>
    </Box>
  );
};

export default LoginForm;
